import React from 'react';
import { useMediaQuery } from 'react-responsive';

import { BadgesCandidateIdTypes } from '../../types';
import {
  ButtonColour,
  ButtonStyle,
  ButtonTarget,
} from 'components/Button/constants';
import { defaultValues, model, schema } from '../model';
import { useSubmitCandidate } from '../../hooks/useSubmitCandidate';
import * as Button from 'components/Button';
import * as Hyperlink from 'components/Hyperlink';
import * as Question from 'components/Question';
import Questions from 'components/Questions';

import styles from './styles.module.scss';
import Skeleton from './Skeleton';

type NewCandidateProps = {
  candidateId?: BadgesCandidateIdTypes[];
  cancelPolling: () => void;
  loaded: boolean;
  setCandidateIds: React.Dispatch<
    React.SetStateAction<BadgesCandidateIdTypes[] | undefined>
  >;
};

const NewCandidateId: React.FunctionComponent<NewCandidateProps> = ({
  candidateId,
  cancelPolling,
  loaded,
  setCandidateIds,
}) => {
  const { handleSubmit, isApiSubmitting, candidateErrorState } =
    useSubmitCandidate(setCandidateIds, cancelPolling);

  const placeholderBreakpoint = useMediaQuery({
    query: '(max-width: 360px)',
  });

  const placeholder = placeholderBreakpoint
    ? 'Candidate Number'
    : 'Enter Your Candidate Number';

  return loaded ? (
    <React.Fragment>
      {candidateId && candidateId.length === 0 && (
        <div className={styles.newCandidateId}>
          <h2>
            Start your path!
            <br />
            Add a Candidate Number to claim your first badge.
          </h2>
          <Questions
            className={styles.newCandidateIdForm}
            defaultValues={defaultValues}
            enableReinitialize={true}
            onSubmit={handleSubmit}
            schema={schema}
          >
            {({ control, isFormSubmitting }) => (
              <React.Fragment>
                <Question.Text
                  control={control}
                  help="This is the long number that can usually be found on your exam certificate or in the personal details section of your PeopleCert account."
                  label={placeholder}
                  question={model.candidateId}
                  isSubmitting={isApiSubmitting || isFormSubmitting}
                />
                <Button.Submit
                  ariaLabel="Submit"
                  colour={ButtonColour.BRAND_BERRY}
                  disabled={isApiSubmitting || isFormSubmitting}
                  isSubmitting={isApiSubmitting || isFormSubmitting}
                  style={ButtonStyle.PRIMARY}
                  small
                />
              </React.Fragment>
            )}
          </Questions>
          {candidateErrorState && (
            <p className={styles.errorResponse}>
              Sorry, we don't recognise this candidate number. Please try again
              or visit our{' '}
              <Hyperlink.PageLink
                rel="noreferrer"
                slug="/help"
                target={ButtonTarget.BLANK}
              >
                Help page
              </Hyperlink.PageLink>
            </p>
          )}
        </div>
      )}
    </React.Fragment>
  ) : (
    <Skeleton />
  );
};

export default NewCandidateId;
